import type { FuelUser, FuelUserInfo } from '../../../models/user';

export interface UserRole {
  id: string;
  name: string;
}
class UserInfoForm {
  id: string = null;
  dataType: string = 'User';
  objId: string = null;
  userId: string = null;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  accessibleResourceIds: string[] = [];
  enableMFA: boolean = false;

  static create(): UserInfoForm {
    const form = new UserInfoForm();
    return form;
  }
}

export class UserManagementForm {
  entityType: string = 'FuelUser';
  availableRoles: UserRole[] = [];
  roles: string[] = [];
  userInfo: FuelUserInfo = UserInfoForm.create();
  id: string = null;
  originalUser: FuelUser = null;
  enabled: boolean = true;
  apiKeyAccessRights: any = {};

  static create(roles: string[]): UserManagementForm {
    const form = new UserManagementForm();
    form.availableRoles = form.generateRoles(roles);
    return form;
  }

  static createFromData(user: FuelUser, availableRoles): UserManagementForm {
    // console.log('createFromData', { user, availableRoles });
    const form = new UserManagementForm();
    form.roles = user.roles ? user.roles : [];
    form.availableRoles = form.generateRoles(availableRoles);
    form.entityType = user.entityType;
    form.id = user.id;
    form.userInfo = user.userInfo;
    form.originalUser = user;
    form.enabled = user.enabled ?? false;
    form.apiKeyAccessRights = user.apiKeyAccessRights;

    return form;
  }
  generateRoles(roles: string[]): UserRole[] {
    const items = roles.map((role) => {
      return {
        id: role,
        name: role,
      };
    });
    return items;
  }
}
